import Highcharts from 'highcharts';
import { getEmploymentData } from "./chart-salaries";

/**
 * @param {string} id
 */
export default function chartVacancies(id) {
    if (!document.getElementById(id)) return;

    // Filter cities with meaningful vacancy data (at least guards > 0)
    // Sort by vacancy rate desc
    const cityData = getEmploymentData()
        .filter(item => item.filledGuards > 0)
        .sort((a, b) => b.vacancyRate - a.vacancyRate);

    const categories = cityData.map(item => item.city);
    const filledData = cityData.map(item => item.filledGuards);
    const vacantData = cityData.map(item => item.vacantGuards);

    Highcharts.chart(id, {
        chart: { type: 'bar', backgroundColor: 'transparent' },
        title: { text: 'Etaty obsadzone a wakaty w straży miejskiej' },
        xAxis: {
            categories: categories,
            title: { text: null },
            labels: { style: { fontSize: '14px' } }
        },
        yAxis: {
            min: 0,
            title: { text: 'Liczba etatów' },
            reversedStacks: false // Vacancies on top or right
        },
        tooltip: {
            pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
            shared: true
        },
        plotOptions: {
            series: {
                stacking: 'normal',
                dataLabels: {
                    enabled: false
                }
            }
        },
        legend: {
            reversed: true // Matches stack order
        },
        credits: { enabled: false },
        series: [{
            name: 'Obsadzone etaty',
            data: filledData,
            color: '#3498db'
        },{
            name: 'Wakaty',
            data: vacantData,
            color: '#e74c3c',
            dataLabels: {
                enabled: true,           // Włączamy tylko dla wakatów
                inside: false,          // Wyciągamy na zewnątrz słupka
                align: 'left',          // Wyrównujemy do lewej względem punktu zaczepienia
                x: 5,                   // Przesuwamy o 5px w prawo od końca słupka
                format: '{point.percentage:.0f}%',
                style: {
                    color: '#000',
                    textOutline: 'none',
                    fontSize: '12px'
                },
                crop: false,            // Zapobiega ucinaniu etykiety przy krawędzi wykresu
                overflow: 'allow'       // Pozwala etykiecie wyjść poza obszar rysowania
            }
        }]
    });
}
